<template>
  <div class="d-flex flex-row justify-content-center align-items-center">
    <div class="d-flex flex-row justify-content-center align-items-center w-75">
      <mdb-btn
        rounded
        size="sm"
        class="mt-0 mr-3"
        :style="{padding: '.5rem 1rem'}"
        gradient="aqua"
        icon="map"
        @click.native="mapModal = true"
        :title="`Open Google map to pick ${pointType} point`"
      />
      <bridge8-autocomplete
        outline
        class="m-0 route-point-select w-100"
        isAsync
        :label="capitalizedPointType"
        :async-loading-text="'Loading.....'"
        :is-object-data="true"
        :is-extended="true"
        :filter-required="false"
        :min-chars-to-search="2"
        :object-data-text-callback="objectDataTextCallback"
        :object-table-data-callback="objectTableDataCallback"
        :icon-callback="iconCallback"
        :search-string="searchString"
        v-model="searchString"
        :data="routePointOptions[pointType]"
        @input="onInput($event)"
        @change="setPoint($event)"
      />
    </div>
    <div class="w-25 mb-1">
      <mdb-input
        type="checkbox"
        label="Include Alternatives"
        :name="`${pointType}_alternatives`"
        :id="`${pointType}_alternatives`"
        v-model="isUseAlternativesChecked"
        @change="setUseAlternatives($event)"
      />
    </div>
    <calc-controls-route-point-select-map-modal
      :show="mapModal"
      :key="`${pointType}-map-modal-key`"
      :point-type="pointType"
      :search-string="searchString"
      @modal-close="mapModal = false"
      @pick-point="pickPoint"
    />
  </div>
</template>

<script>
import { RoutePointTypes } from '../enums'
import Bridge8Autocomplete from './Bridge8Autocomplete'
import { mdbInput, mdbBtn, mdbIcon } from 'mdbvue'
import { mapState, mapActions } from 'vuex'
import {capitalize, determineLocationTypeIcon, errorCatch} from '../utils'
import CalcControlsRoutePointSelectMapModal from './CalcControlsRoutePointSelectMapModal'
import Calc from './Calc'

export default {
  name: 'CalcControlsRoutePointSelect',
  data: function () {
    return {
      searchString: '',
      isUseAlternativesChecked: null,
      delayCounter: null,
      mapModal: false
    }
  },
  props: {
    pointType: {
      validator: (prop) => Object.values(RoutePointTypes).includes(prop)
    }
  },
  computed: {
    ...mapState('calc', {
      routePoints: state => state.query.routePoints,
      routePointOptions: state => state.routePointOptions,
      routeByCoordinates: state => state.query.routeByCoordinates,
      useAlternatives: state => state.query.useAlternatives
    }),
    capitalizedPointType: function () {
      return capitalize(this.pointType)
    }
  },
  methods: {
    ...mapActions('calc', [
      'setRoutePoint',
      'setQueryUseAlternatives',
      'setQueryRouteByCoordinates',
      'setRoutePointOptions',
      'pickPointFromMap'
    ]),
    setUseAlternatives (checked) {
      if (checked !== this.isUseAlternativesChecked) {
        this.setQueryUseAlternatives({pointType: this.pointType, checked: checked})
          .then(() => {
            this.$bus.$emit('query-change')
          })
      }
    },
    setPoint (point) {
      const location = this.routeByCoordinates[this.pointType]
        ? point : (point ? Object.assign(point.location, {type: point.type}) : null)
      this.setRoutePoint({pointType: this.pointType, location: location})
        .then(() => {
          this.$bus.$emit('query-change')
        })
    },
    pickPoint (point) {
      this.setQueryUseAlternatives({pointType: this.pointType, checked: false})
        .then(() => {
          this.mapModal = false
          this.pickPointFromMap({pointType: this.pointType, point: point})
            .then(() => {
              this.searchString = point.description
              this.$bus.$emit('query-change')
            })
        })
    },
    objectDataTextCallback (obj) {
      if (this.routeByCoordinates[this.pointType]) {
        return obj.description && obj.description.length > 50 ? obj.description.substring(0, 48) + '...' : obj.description
      }
      return obj.location.name + (obj.location.commonName ? ` - ${obj.location.commonName}` : '')
    },
    objectTableDataCallback (obj) {
      return Object.assign({}, obj, obj.location)
    },
    iconCallback (obj) {
      if (this.routeByCoordinates[this.pointType]) {
        return null
      }
      return determineLocationTypeIcon(obj.type)
    },
    onInput () {
      if (this.routeByCoordinates[this.pointType]) {
        this.setQueryRouteByCoordinates({pointType: this.pointType, isSet: false})
      }
    }
  },
  mounted () {
    this.isUseAlternativesChecked = this.useAlternatives[this.pointType]
    this.$bus.$on('clone-request', ({request}) => {
      this.setRoutePoint({pointType: this.pointType, location: request[this.pointType]})
      this.searchString = this.objectDataTextCallback({location: request[this.pointType]})
    })
  },
  watch: {
    searchString: function (newVal, oldVal) {
      this.delayCounter = window.performance.now()
      setTimeout(
        () => {
          if (window.performance.now() - this.delayCounter > 500 && newVal.length >= 2) {
            this.setRoutePointOptions({searchString: newVal, pointType: this.pointType})
              .catch(errorCatch('Set Route Point Options failed', this))
          }
        },
        500
      )
    }
  },
  components: {
    Calc,
    mdbInput,
    mdbBtn,
    mdbIcon,
    Bridge8Autocomplete,
    CalcControlsRoutePointSelectMapModal
  }
}
</script>

<style lang="sass">
.form-check-label
  margin-right: 1em!important
</style>



// WEBPACK FOOTER //
// src/components/CalcControlsRoutePointSelect.vue